import carrousel1 from "../../../../assets/carrousel.png";
import carrousel2 from "../../../../assets/carrousel2.png";
import carrousel3 from "../../../../assets/carrousel3.png";
import carrousel4 from "../../../../assets/carrousel4.png";

const dataSlider = [
  {
    id: 1,
    img: carrousel1,
    title: "Lo simple,",
    subTitle: "lo natural",
    text: "Una manera simple, rica y saludable de consumir frutas y verduras",
    textimg: "corrousel1"
  },
  {
    id: 2,
    img: carrousel2,
    title: "Súmate al", 
    subTitle: "desafío Detox",
    text: "Depurá y renová el oxígeno de tu cuerpo y mente",
    textimg: "corrousel2"
  },
  {
    id: 3,
    img: carrousel3,
    title: "La naturaleza en", 
    subTitle: "nuestros jugos",
    text: "Frutas y verduras seleccionadas con un estricto control de calidad para brindarte solo lo mejor",
    textimg: "corrousel3"
  },
  {
    id: 4,
    img: carrousel4,
    title: "Hacé tu pedido",
    subTitle: "saludable de la semana",
    text: "Contáctanos a través de todos los medios disponibles que tenemos para vos",
    textimg: "corrousel4"
  },
];

export default dataSlider;